import { gql } from '@apollo/client';

export const EXISTING_PROJECT_STATUS_CHANGE_APPROVALS = gql`
  query MyQuery($projectId: ID!) {
    checkPendingApprovals(type: PROJECT_STATUS_CHANGE, projectId: $projectId) {
      metadata
    }
  }
`;

export const GET_PROJECT = gql`
  query MyQuery($id: ID!) {
    getProject(id: $id) {
      nextStatus {
        action
        currentState
        nextState
      }
      id
      colorCode
      projectName
      clientName
      projectStatus
      tentativeEndDate
      tentativeStartDate
      hypercarePeriod
      createdAt
      createdById
      members {
        id
        hoursPerWeek
        roleEndDate
        roleStartDate
        memberStatus
        assignedAt
        member {
          id
          displayName
          providerId
        }
        memberRoles {
          id
          projectRole {
            id
            displayName
            role
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_ROLES = gql`
  query MyQuery {
    getProjectRoles {
      id
      displayName
      role
    }
  }
`;

export const UPDATE_PROJECT_STATUS = gql`
  mutation MyMutation(
    $actionUserId: ID!
    $id: ID!
    $projectName: String!
    $projectStatus: ProjectStatus!
    $tentativeStartDate: AWSDateTime!
    $tentativeEndDate: AWSDateTime!
    $projectType: String!
    $hypercarePeriod: Int!
    $projectManagerId: ID!
  ) {
    editProject(
      input: {
        actionUserId: $actionUserId
        id: $id
        projectName: $projectName
        projectStatus: $projectStatus
        tentativeStartDate: $tentativeStartDate
        tentativeEndDate: $tentativeEndDate
        projectType: $projectType
        hypercarePeriod: $hypercarePeriod
        projectManagerId: $projectManagerId
      }
    )
  }
`;
